
<div class="header-toolbar">
  <h1>
    Sociétés

    <span class="tag" *ngIf="filter.search">
      <span class="text">Recherche: {{ filter.search }}</span>
      <t-icon name="close" title="Supprimer ce filtre" (click)="clearSearch()"></t-icon>
    </span>
  </h1>
</div>

<!-- Toolbar -->
<div class="main btn-toolbar">

  <div class="btn-group">
    <div class="content">
      
      <a class="btn" [routerLink]="'/documents-ledger/companies/new'">
        <t-icon name="add"></t-icon>
        <span class="text">Ajouter</span>
      </a>
      <button class="btn" (click)="applyFilter()">
        <t-icon name="search"></t-icon>
        <span class="text">Filtrer</span>
      </button>

    </div>
  </div>

</div>
<!-- /Toolbar -->

<table>

  <thead>
    <tr>
      <th>Nom</th>
      <th style="width: 320px">Créée par</th>
      <th style="width: 110px">Date d'ajout</th>
      <th style="width: 100px;"></th>
    </tr>
  </thead>

  <tbody *ngIf="companies && companies.length > 0">
    <tr *ngFor="let company of companies" (click)="showDLCompany(company, $event)">
      <td name="Nom">
        {{ company.fullname }}
      </td>
      <td name="Créée par" style="width: 320px">
        {{ company.createdBy.fullname }}
      </td>
      <td name="Date d'ajout" style="width: 110px">
        {{ company.createdAt | tzdate:'short' }}
      </td>
      <td style="width: 100px;" class="actions">
        <a class="action-btn" title="Modifer" [routerLink]="[company.id, 'edit']">
          <t-icon name="mode_edit"></t-icon>
        </a>
        <a class="action-btn" title="Supprimer" (click)="delete(company)">
          <t-icon name="delete"></t-icon>
        </a>
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="!companies || companies.length == 0">
    <tr>
      <td class="text-center" colspan="4">
        <ng-container *ngIf="companies && companies.length == 0">
          Aucune société n'a été trouvée
        </ng-container>
        <ng-container *ngIf="!companies">
          Chargement...
        </ng-container>
      </td>
    </tr>
  </tbody>

</table>

<div class="pagination" *ngIf="companies">
  <button class="btn btn-gray" (click)="fetchMore()" *ngIf="companies.length < companiesCount">
    <t-icon name="arrow_downward"></t-icon>
    <span class="text">Afficher plus</span>
  </button>
  <div class="page-number">
    {{ companies.length }} / {{ companiesCount }}
  </div>
</div>